export const FULL_APPLICATION_TITLE = 'Konflux';
